import {axiosInstance} from "./base"


export function getNotificationsQry(params) {
    return axiosInstance.get("api/notifications/", {params})
}

export function deleteNotificationsQry(id) {
    return axiosInstance.delete(`api/notifications/${id}`, {})
}

export function deleteNotifications(ids) {
    return axiosInstance.post(`api/notifications/delete/`, {notifications: ids}, {})
}

export function markNotificationsRead(ids) {
    return axiosInstance.post(`api/notifications/mark-as-read/`, {notifications: ids}, {})
}

export function patchNotificationsQry(id, data) {
    return axiosInstance.patch(`api/notifications/${id}/`, data, {})
}

/* ---- Notification preferences (Lot 5) ---- */

export function getNotificationPreferencesQry() {
    return axiosInstance.get("api/notification-preferences/", {})
}

export function postNotificationPreferenceQry(data) {
    return axiosInstance.post("api/notification-preferences/", data, {})
}

export function patchNotificationPreferenceQry(id, data) {
    return axiosInstance.patch(`api/notification-preferences/${id}/`, data, {})
}

export function deleteNotificationPreferenceQry(id) {
    return axiosInstance.delete(`api/notification-preferences/${id}/`, {})
}
